import { $generateHtmlFromNodes } from '@lexical/html';
import { OnChangePlugin as LexicalOnChangePlugin } from '@lexical/react/LexicalOnChangePlugin';
import PropTypes from 'prop-types';
import { useCallback } from 'react';

const OnChangePlugin = ({ onChange }) => {
  const onChangeHandler = useCallback(
    (editorState, editor) => {
      editorState.read(() => {
        onChange({
          ...editorState,
          getContentInHtml: () => $generateHtmlFromNodes(editor),
        });
      });
    },
    [onChange]
  );

  return <LexicalOnChangePlugin onChange={onChangeHandler} />;
};

OnChangePlugin.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default OnChangePlugin;
